<template>
    <transition name="slide-fade">
        <div class="modal" :class="{'open' : open}" v-if="open" data-cy="modal_loading">
            <div class="backdrop-area" data-cy="container_backdrop_area" @click="hide()"></div>
            <div class="modal-content" data-cy="container_modal_content">
                <div class="w-full" data-cy="container_loading_content">
                    <div><img class="m-auto" :src="initImageUrls()" data-cy="img_loading" /></div>
                    <div class="text-14 text-center text-a-gray-a4a4a4 pt-2" data-cy="text_loading">{{lbl.loading}}</div>
                </div>
            </div>
        </div>
    </transition>

    <transition name="fade">
        <div class="modal-backdrop" v-if="open" data-cy="container_modal_backdrop"></div>
    </transition>
</template>
<script>
//mixin
import LocaleMixin from '@/mixin/LocaleMixin.js';
import ConfigManager from "@/config/ConfigManager.js";
export default {
    name: "NoInternetModal",
    mixins: [LocaleMixin],
    props: {
        controller: Object,
    },
    data: function() {
        return {
            open: false,
            busModal: null,
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
    },
    mounted: function() {
        this.busModal.on('show', this.show);
        this.busModal.on('hide', this.hide);
    },
    watch: {
        '$route.path': function() {
            if (this.open) {
                this.hide();
            }
        },
    },
    methods: {
        show: function() {
            document.body.classList.add('not-scroll');
            this.open = true;
        },
        hide: function() {
            document.body.classList.remove('not-scroll');
            this.open = false;
        },
        initImageUrls: function() {
            var appId = ConfigManager.getAppId();
            var baseUrl = ConfigManager.getBlobUrl()+ `/webconfig/${appId}/images/`;
            
            // images loading
            return baseUrl + 'image/img-loading.png';
        },
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/modal.scss";
    .modal {
        @extend %modal;
        pointer-events: none;
        .modal-content {
            width: 200px;
        }
        .modal-dialog{
            pointer-events: all;
        }
    }
</style>
